export function Trustly({ className = "" }) {
  return (
    <svg
      role="img"
      aria-label="Trustly, logotyp"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1250 416"
      className={className}>
      <path
        fill="#0ee06e"
        d="M458.4 291.8V156.7h-48.5v-32.1h131.9v32.1h-48.5v135.1h-34.9z"
      />
      <path
        fill="#0ee06e"
        d="M536.3 291.8V170.5h32.1v19.2c7.6-16.3 17.4-19.2 27.9-19.2h12.4V203h-10.5c-15.1 0-28.6 8.7-28.6 35.3v53.6h-33.3zm87.5-44.4v-76.9H657v69.4c0 14.2 6.9 24.7 21.1 24.7 13.7 0 22.4-10.5 22.4-24.5v-69.6h33.2v121.4h-31.6v-15.3c-8 12.1-19.9 18.1-35 18.1-26.6-.1-43.3-18.4-43.3-47.3zm124.1 10.3l28.9-6.6c1.4 9.4 8.9 16.5 23.4 16.5 11.2 0 17.4-4.6 17.4-10.3 0-4.6-2.5-8-14-10.5l-19-4.1c-24.3-5.3-34.6-16.5-34.6-36.9 0-20.8 17.2-37.6 49.5-37.6 34.3 0 48.1 20.6 49.5 34.1l-29.1 6.4c-1.4-7.1-6.6-14.9-21.1-14.9-9.2 0-16 4.1-16 10.1 0 5 3.4 7.8 9.4 9.2l27.7 6.4c21.1 4.8 30.9 17.4 30.9 35.3 0 19.2-15.3 39.4-50.4 39.4-38.6-.1-51.2-23.2-52.5-36.5zm166.7 34.1c-21.5 0-35.9-11.9-35.9-35.5v-56.8h-20.4v-29.1h20.4v-27l33.2-9.6v36.6h24.5v29.1h-24.5v50.8c0 8.9 4.6 12.4 13.5 12.4h12.8v29.1h-23.6zm41.6 0V124.7h33.2v167.2h-33.2zm133.3-121.3h35.5l-50.6 164.9h-35.5l14-43.5h-18.3l-33.4-121.4h35.5l25 93.9 27.8-93.9zM125 197.9h77.9v-62.2l62.2 62.2-62.2 62.1v31.8h75.5v-93.9h69.3v-73.2H125z"
      />
    </svg>
  )
}
